import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <>
      <meta name="robots" content="noindex, nofollow" />
      <link rel="canonical" href="https://solus-it.com.br/" />
      <title>Página não encontrada — Solus IT</title>

      <div className="relative flex flex-col items-center justify-center min-h-screen text-center px-4 bg-white">
        <span className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-gray-50 select-none pointer-events-none z-0">
          404
        </span>
        <div className="relative z-10 flex flex-col items-center gap-4">
          <p className="text-5xl font-black text-gray-200 select-none">404</p>
          <h1 className="text-xl md:text-2xl font-semibold text-gray-800">
            Página não encontrada
          </h1>
          <p className="text-base text-gray-400 font-mono break-all max-w-md">
            {location.pathname}
          </p>
          <p className="text-base text-gray-500 max-w-sm">
            A URL que você acessou não existe neste site.
          </p>
          <Link
            to="/"
            className="mt-2 inline-block bg-gray-900 text-white text-sm font-medium px-6 py-3 rounded-lg hover:bg-gray-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            Voltar ao início
          </Link>
        </div>
      </div>
    </>
  );
}
